import React, { useState } from 'react';
import { Box, Card, Button, alpha } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom'; // Importing useNavigate hook for navigation
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { useInfoViewActionsContext } from '@projectK/context';
import PopupRequest from '../PopupRequest';
function renderHtml(html) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

const AddonsCards = ({ item, companyTheme }) => {
  const { user } = useAuthUser();
  const navigate = useNavigate();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [addName, setAddName] = useState(false);
  
const getTag = () => {
  if (!item?.add_status) {
    return item?.type === 'free' ? 'Free' : 'Premium';
  }
  return item.add_status;
};

const getTagColor = () => {
  switch (item?.add_status) {
    case 'active':
      return 'available_btn';
    case 'expiring today':
      return 'expiring_today_btn';
    case 'expiring tomorrow':
      return 'expiring_tomorrow_btn';
    case 'expired':
      return 'expired_btn';
    case 'in-active':
      return 'inactive_btn';
    case 'not started at':
      return 'not_started_btn';
    default:
      return item?.type === 'free' ? 'available_btn' : 'premium_btn';
  }
};

  const localStorageUrl = item?.logo_url
    ? `${process.env.NX_CLOUD_FRONT_URL}/${item.logo_url}`
    : '';

  const handleDemoRequest = async (id, addons_name) => {
    try {
      setAddName(addons_name);
      await jwtAxios.post('/addon-demoRequest', {
        user_id: user.id,
        user_email: user.email,
        user_role: user.role[0],
        addon_id: id,
      });
      setIsDialogOpen(true);
    } catch (error) {
      infoViewActionsContext.fetchError(
        error?.response?.data?.error || error?.response,
      );
    }
  };

  return (
    <>
      <Card
        sx={{
          boxShadow: 3,
          overflow: 'hidden',
          '&:hover': {
            boxShadow: 6,
          },
        }}
        className='addons-card'
      >
        <Button
          variant='contained'
          size='small'
          className={`status_btn ${getTagColor()}`}
        >
          {getTag()}
        </Button>
        <Box
          className='addons_header'
          sx={{
            display: 'flex',
            padding: 3,
            gap: 2,
          }}
        >
          {localStorageUrl ? (
            <Box className='img_box' sx={{ display: 'flex' }}>
              <img
                src={localStorageUrl} // Image URL from item
                alt={item.addons_name} // Alt text for image
              />
            </Box>
          ) : null}

          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            {/* Title */}
            <Box
              sx={{
                fontWeight: 'bold',
                fontSize: 20,
                color: companyTheme ? companyTheme.primary.main : 'primary', // Use the primary color or fallback to default
                marginBottom: 1,
              }}
              component='h3'
            >
              {item.name}
            </Box>

            <Box
              sx={{
                fontSize: 14,
                color: 'rgb(107, 114, 128)', // Use the secondary text color or fallback to default
                marginBottom: 2,
                whiteSpace: 'wrap',
              }}
            >
              {item.tagline}
            </Box>
          </Box>
        </Box>

        <Box className='description'>
          <Box>
            {renderHtml(item?.short_description)}
            {/* short Description */}
          </Box>
          <Box>
            Price: <span style={{ fontWeight: 500 }}>${item?.price}</span>
            {/* short Description */}
          </Box>
        </Box>

        {/* Buttons Section */}
        <Box
          className='bottom_btns'
          sx={{
            padding: 3,
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='outlined'
            size='medium'
            onClick={() => navigate(`viewmarket/${item.slug_name}`)}
            sx={{
              borderColor: companyTheme ? companyTheme.primary.main : '#2196f3',
              '&:hover': {
                borderColor: companyTheme
                  ? alpha(companyTheme.primary.main, 0.8)
                  : alpha('#2196f3', 0.8),
              },
              color: companyTheme ? companyTheme.primary.main : 'primary',
            }}
          >
            View Details
          </Button>
          <Button
            variant='contained'
            size='medium'
            disabled={item?.add_status !== null && item?.add_status === 'active'}
            onClick={() => handleDemoRequest(item.id, item.name)}
            sx={{
              backgroundColor: companyTheme
                ? companyTheme.primary.main
                : '#2196f3',
              '&:hover': {
                backgroundColor: companyTheme
                  ? alpha(companyTheme.primary.main, 0.8)
                  : alpha('#2196f3', 0.8),
              },
            }}
          >
            Request Activation
          </Button>
        </Box>
      </Card>

      {isDialogOpen && (
        <PopupRequest
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
          companyTheme={companyTheme}
          addonName={addName}
        />
      )}
    </>
  );
};

export default AddonsCards;
AddonsCards.propTypes = {
  item: PropTypes.object,
  companyTheme: PropTypes.object,
};
